
import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { InformableSection } from 'globals/store/informables.data';
import { Asset } from 'globals/store/assets.data';
import { CommonModule } from '@angular/common';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { ExpandableInfoComponent } from '../information/expandable-info.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'public-informable',
    template: `
<ng-template #items let-items="items">
  <ng-container *ngFor="let item of items">
    <expandable-info  
      [lightOnCollapse]="true"
      class="item" 
      [assets]="!assets ? null : (item?.assetIds || []) | idsToItems:assets"
      [initClosed]="itemsInitClosed" 
      [manualToggle]="manualToggle"
      [open]="openedItems[item.id]"
      [item]="item"
      (onToggle)="toggleItem(item.id)"
    ></expandable-info>
  </ng-container>
</ng-template>  

<ng-template #sections let-information="information">
  <ng-container class="multiSections" *ngFor="let info of information">
    <expanding-wrapper class="public-info" *ngIf="info.items?.length"
      [initOpen]="!sectionsInitClosed"
      [title]="info.title"
      [manualToggle]="manualToggle"
      [expandedState]="openedSections[info.id] ? 'expand' : 'collapse'"
      (onToggle)="toggleSection(info.id)"
      [borderGreyOnCollapse]="true"
    >
      <ng-container [ngTemplateOutlet]="items" [ngTemplateOutletContext]="{items:info.items}"></ng-container>
    </expanding-wrapper>
  </ng-container>
</ng-template>
<ng-container *ngIf="!singleSectionOnly" [ngTemplateOutlet]="sections" [ngTemplateOutletContext]="{information:information}"></ng-container>
<ng-container *ngIf="singleSectionOnly" [ngTemplateOutlet]="items" [ngTemplateOutletContext]="{items:information[0].items}"></ng-container>
  `,
    styleUrls: ['./public-informable.scss'],
    standalone: true,
    imports: [CommonModule, ExpandingWrapperComponent, ExpandableInfoComponent, IdsToItemsPipe],
})
export class InformablePublicComponent implements OnInit {

  @Input() information: InformableSection[]
  @Input() assets: Dictionary<Asset>
  @Input() sectionsInitClosed = true
  @Input() itemsInitClosed = false
  @Input() singleSectionOnly: boolean
  @Input() showEmptyItems = false
  @Input() manualToggle = false

  openedItems = {}
  openedSections = {}

  ngOnInit() {
    // console.log(this)
  }

  toggleSection(id: string) {
    this.openedSections[id] = !this.openedSections[id]
  }

  toggleItem(id: string) {
    this.openedItems[id] = !this.openedItems[id]
  }

  expandAll() {
    console.log("expand all called")
    this.information.forEach(info => {
      this.openedSections[info.id] = true
      info.items.forEach(item => this.openedItems[item.id] = true)
    })
  }

  collapseAll() {
    console.log("collapse all called")
    this.openedItems = {}
    this.openedSections = {}
  }

}